module.exports = __webpack_public_path__ + "src/assets/img/page3/dd35502712290835fb3f0175adeaf972.png";